<template>
    <div class="col-span-2 h-12 ml-4">
        <div class="text-gray-700 font-medium text-sm right lg:text-right pl-2">
            Saldo conta OTC
        </div>
        <div class="relative">
            <div
                class="font-bold text-gray-800 text-xl text-right pl-2">
                <span class="text-base">R$</span> {{ $page.props.activeAccount.crypto_balance | currency }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        short: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showBalance: false,
            balance: {
                value: null,
                blocked: null,
                updated: null
            }
        }
    },
    created() {
    },
    methods: {
        loadBalance() {
            this.showBalance = !this.showBalance
        }
    }
}
</script>
